module.exports = __webpack_public_path__ + "media/images/desktop/header-bookshelf@2x-43550e0af1dc5cf3b0d4b3f4c1911ea3.png";